import { Drawer } from '@mui/material';
import { Icon } from '@thro-types/users';

import { Formik, FormikErrors } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useIconsMutation } from 'api/hooks/useIconsQuery';
import { AlertActions } from 'app/containers/Dashboard/Alert/slice';
import {
  drawerSliceKey,
  IconDrawerActions,
  iconDrawerReducer
} from 'app/containers/Settings/TileSettings/iconDrawerSlice';
import { selectIconDrawer } from 'app/containers/Settings/TileSettings/selectors';
import { translations } from 'locales/i18n';
import { useInjectReducer } from 'utils/redux-injectors';

import { IconDrawerContent, IconValues } from './components/IconDrawerContent';
import { uploadIconToS3 } from './helper';
import { iconValidationSchema, initialCardValues } from './validation';

interface IconDrawerProps {}

export const IconDrawer = (props: IconDrawerProps) => {
  useInjectReducer({ key: drawerSliceKey, reducer: iconDrawerReducer });
  const { t } = useTranslation();
  const iconDrawer = useSelector(selectIconDrawer);
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const { create } = useIconsMutation();

  const handleSave = async (values: IconValues) => {
    if (submitting || !values.iconToUpload) {
      return;
    }
    setSubmitting(true);
    try {
      let uploadResult = await uploadIconToS3({
        file: values.iconToUpload,
        icon: values.icon,
        type: values.type
      });
      values.icon = uploadResult;
      dispatch(
        AlertActions.success(t(translations.pages.tileSettings.alerts.successfulIconCreate()))
      );
    } catch (error) {
      dispatch(AlertActions.error(t(translations.common.alerts.failedImageUpload())));
      setSubmitting(false);
    } finally {
      setSubmitting(false);
      dispatch(IconDrawerActions.close());
    }
  };

  const renderContent = () => {
    return <IconDrawerContent />;
  };
  return (
    <Drawer
      anchor="right"
      open={iconDrawer.open}
      onClose={() => dispatch(IconDrawerActions.close())}
      PaperProps={{
        sx: { width: { xs: '70%', md: '35%', xl: '25%' } }
      }}
    >
      <Formik
        initialValues={initialCardValues()}
        onSubmit={values => handleSave(values)}
        validationSchema={iconValidationSchema(t)}
        validateOnMount
      >
        {renderContent()}
      </Formik>
    </Drawer>
  );
};
